/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { http } from "@/api/index";

import {

	GET_TREND_SIGNAL_SETTINGS,
	GET_TREND_SIGNAL_SETTINGS_ERROR,
	GET_TREND_SIGNAL_SETTINGS_SUCCESS,

} from "@/stores/actions/TrendSignalSettings";

const state = {
	data:   [],
	status: FetchStatus.Init,
	error:  {},
};

const actions =
{
	[GET_TREND_SIGNAL_SETTINGS]: ({ commit }, monitoringElementId) =>
	{
		commit(GET_TREND_SIGNAL_SETTINGS);
		http.get(`/TrendSignalSettings/${monitoringElementId}`).then((resp) =>
		{
			if (resp.status !== 200)
			{
				commit(GET_TREND_SIGNAL_SETTINGS_ERROR, resp.status);
			}
			else
			{
				commit(GET_TREND_SIGNAL_SETTINGS_SUCCESS, resp.data);
			}
		}).catch((error) =>
		{
			commit(GET_TREND_SIGNAL_SETTINGS_ERROR, error.response);
		});
	},
};

const mutations = {
	[GET_TREND_SIGNAL_SETTINGS]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},

	[GET_TREND_SIGNAL_SETTINGS_SUCCESS]: (state, data) =>
	{
		state.data = data;
		state.status = FetchStatus.Loaded;
	},
	[GET_TREND_SIGNAL_SETTINGS_ERROR]: (state, error) =>
	{
		state.error = error;
		state.status = FetchStatus.Error;
	},
};

export default {
	state,
	actions,
	mutations,
};
